import React from 'react'
import Intro from '../snippets/intro'

class About extends React.Component {
    constructor(){
        super();
        this.state={
            active: "false"
        }
    }

    componentDidMount(){
        setTimeout(() => {
            this.setState({
                active: "true"
            })
        }, 500);
    }

    componentWillUnmount(){
        this.setState({
            active: "false"
        })
    }

    render(){
        return(
            <section className="home" activepage={this.state.active}>
                <Intro />
            </section>
        )
    }
}

export default About